import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FuturisticAnimation from '../components/FuturisticAnimation';

/**
 * Full-screen hero animation only — for screen recording (OBS, Xbox Game Bar, etc.)
 * to produce MP4/WebM for social posts. Open /export-animation, optionally F11, record ~10–30s loop.
 */
const AnimationExport = () => {
  const [searchParams] = useSearchParams();
  const showHint = searchParams.get('hint') === '1';

  return (
    <div className="min-h-screen bg-[#0a0e18] flex flex-col items-center justify-center overflow-hidden">
      {/* 1:1 frame — matches common IG/LinkedIn square posts when you crop to this box */}
      <div
        className="relative rounded-lg border border-white/5 shadow-2xl"
        style={{ width: 'min(1080px, 92vmin)', height: 'min(1080px, 92vmin)' }}
      >
        <FuturisticAnimation />
      </div>
      {showHint && (
        <p className="mt-6 max-w-md text-center text-xs text-white/40 px-4">
          Record this square, then trim to loop. Add ?hint=0 or omit hint to hide this line.
        </p>
      )}
    </div>
  );
};

export default AnimationExport;
